// Bibliotecas do framework
import React from "react";

// Barra superior
import Header from "../Header";

export default function Agradecimentos() {
    return (
        <div className="section">
            <Header />

            <div className="content">
                <div className="container">
                    <h3>Novidades Priore</h3>

                    <p>Olá, Bruno aqui. Muitas pessoas passaram pela minha caminhada e prestaram ajuda em algum momento. Não quero ser muito prolixo, mas gostaria de registrar aqui todos que contribuíram de alguma forma.</p>

                    <p>
                        <b>Mestres da depuração</b>:
                        <br />Angélica Lorena dos Santos Oliveira
                        <br />Carlos Henrique Furtado Da Cunha
                        <br />Jean Lucas Meireles Pinheiro
                        <br />Lucas Geőcze Cotrim
                        <br />Thalles Mercês Carreiro
                    </p>

                    <p>
                        <b>Cara do design</b>:
                        <br />Antônio Marcos Costa Santana
                    </p>

                </div>
            </div>

        </div>
    );
}